"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Item.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Item = function Item(_ref) {
  var icon = _ref.icon,
    href = _ref.href,
    title = _ref.title,
    isActive = _ref.isActive,
    onLinkClick = _ref.onLinkClick,
    className = _ref.className;
  var rootClassName = (0, _classnames["default"])('cds-Dashboard-Item', {
    'cds-Dashboard-Item--Active': isActive
  }, className);
  var handleLinkClick = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    onLinkClick(href);
  }, [href, onLinkClick]);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: href,
    onClick: handleLinkClick,
    className: "cds-Dashboard-ItemLink"
  }, icon && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: icon,
    size: _Icon.ICON_SIZE.small,
    className: "cds-Dashboard-ItemIcon"
  }), title));
};
exports.Item = Item;